import angular from 'angular';
import moment from 'angular-moment';
import DateUtil from "../../../../components/logic/date_util/date_util.module";
import PowerFormatter from "../../../../components/logic/power-formatter/power-formatter.logic";
import DailyActivePowerService from '../../../../components/api/daily_active_power/daily_active_power.service';

import chartConfig from './compare-graph-monthly-active.config';

export class CompareGraphMonthlyActiveController {
  /*@ngInject*/
  constructor($filter, $scope, $q, moment, DateUtil, PowerFormatter, DailyActivePowerService) {
    this.$filter = $filter;
    this.$q = $q;
    this.moment = moment;
    this.DailyActivePowerService = DailyActivePowerService;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;

    this.maxDate = this.moment().startOf('day').toDate();
    this.categories = [];
    this.graphUpdating = false;

    this.chartConfig = chartConfig(this);

    $scope.$watch('$ctrl.selectedConfigs', () => this.updateGraph(this.targetDate));
    $scope.$watch('$ctrl.targetDate', () => this.updateGraph(this.targetDate));
  }

  $onInit() {}

  changeMonth(diff) {
    this.updateTargetDate({targetDate: this.moment(this.targetDate).add(diff, 'months').toDate()});
  }

  updateGraph(date) {
    const targetDate = this.moment(date);
    this.startDate = targetDate.clone().startOf('month').toDate();
    this.endDate = targetDate.clone().endOf('month').toDate();

    if (this.chart) {
      this.chart.reflow();
    }

    if (this.selectedConfigs.length === 0) {
      return;
    }
    this.graphUpdating = true;
    this.resetSeries();

    const numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);
    this.categories = [];
    let startUtc = this.DateUtil.localToUTC(this.startDate);
    for (let i = 0; i <= numberOfDays; i++) {
      this.categories.push(this.DateUtil.leapDate(startUtc, i).valueOf());
    }
    this.chart.xAxis[0].setCategories(this.categories);

    const promises = [];
    for (let config of this.selectedConfigs) {
      promises.push(this.getActivePowers(config, this.categories, this.startDate, this.endDate));
    }

    this.$q.all(promises).then(results => {
      for (let result of results) {
        this.addSeries(result.powers, result.config);
      }
      this.chart.redraw();
      this.chart.reflow();
      this.graphUpdating = false;
    });
  }

  getActivePowers(config, categories, startDate, endDate) {
    const dateQuery = this.DateUtil.getDateRangeQueries(startDate, endDate);
    const query = angular.extend({id: config.id}, dateQuery);

    return new Promise(resolve => {
      this.DailyActivePowerService.show(query, res => {
        const powers = this.PowerFormatter.formatDailyActivePowers(res.powers, this.categories);
        resolve({powers, config});
      });
    });
  }

  addSeries(powers, config) {
    if (!powers) {
      return;
    }
    const graphData = this.categories.map((e, i) => {
      const label = this.moment(e).format('MM/DD');
      return [label, powers[i].y];
    });
    this.chart.addSeries({
      name: config.pms_service_code,
      type: this.graphType,
      data: graphData
    }, false);
  }

  resetSeries() {
    if (!this.chart) {
      return;
    }
    while (this.chart.series.length > 0) {
      this.chart.series[0].remove(false);
    }
  }
}

export default angular.module('leptonApp.compareGraphMonthlyActive', [moment, DateUtil, PowerFormatter, DailyActivePowerService])
  .component('compareGraphMonthlyActive', {
    template: require('./compare-graph-monthly-active.html'),
    controller: CompareGraphMonthlyActiveController,
    bindings: {
      selectedConfigs: '=',
      configIds: '=',
      graphType: '=',
      targetDate: '=',
      updateTargetDate: '&'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/active/monthly/compare-graph-monthly-active.component.js